const isEnable = (key) => {
    return process.env[key]==='true'
}
const hasEnvironment = (key) => {
    return process.env[key] && process.env[key].length > 0
}

export default {
    name: "EnvironmentHelper",
    isEnable,
    hasEnvironment
}
